const state = {
  locales: ['en', 'fr', 'es', 'pt', 'de', 'nl'],
  locale: 'fr',
};
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/i18n/state.js